module.exports = __webpack_public_path__ + "img/female1.a0c33d71.png";